import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import BasketItem from "../types/BasketItem";

type Output = BasketItem[];

export default function useGetBasketItems (
    prebookingId: string,
    options?: CacheQueryOpts
): CacheQueryOutput<Output> {
    const client = useAPIClient();
    return useCacheQuery<Output>(
        ["basket-items", prebookingId],
        () => {
          if (!prebookingId) {
            throw new Error('Error getting prebooking ID');
          }
            return client.get<any>("prebookings/" + prebookingId + "/rooms");
        },
        options
    );
}
